var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6411 4.95318C16.153 3.94942 14.3852 3.44254 12.5913 3.50518C10.7974 3.56783 9.06933 4.19678 7.65484 5.30191C6.24034 6.40704 5.21201 7.9316 4.71723 9.65708C4.60306 10.0553 4.18773 10.2855 3.78956 10.1713C3.39139 10.0571 3.16117 9.64179 3.27534 9.24363C3.85743 7.21364 5.06723 5.42004 6.73134 4.11989C8.39546 2.81974 10.4285 2.07979 12.539 2.00609C14.6495 1.93239 16.7291 2.52873 18.4799 3.70963C20.2306 4.89053 21.5626 6.59537 22.2849 8.5798C22.4266 8.96904 22.2259 9.39942 21.8366 9.54109C21.4474 9.68276 21.017 9.48207 20.8753 9.09283C20.2614 7.40606 19.1292 5.95695 17.6411 4.95318Z",
    fill: "#004FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3871 19.2108C9.78245 20.0817 11.4005 20.529 13.045 20.4985C14.6896 20.4681 16.2899 19.9611 17.652 19.0391C19.0142 18.1172 20.0795 16.8198 20.719 15.3044C20.88 14.9227 21.3199 14.7439 21.7015 14.9049C22.0832 15.066 22.262 15.5059 22.101 15.8875C21.3487 17.6704 20.0953 19.1967 18.4928 20.2813C16.8903 21.366 15.0076 21.9624 13.0728 21.9983C11.1381 22.0341 9.23449 21.5079 7.5929 20.4833C5.95132 19.4588 4.64225 17.98 3.82446 16.2262C3.6494 15.8508 3.81182 15.4045 4.18722 15.2295C4.56263 15.0544 5.00886 15.2168 5.18392 15.5923C5.87905 17.083 6.99175 18.34 8.3871 19.2108Z",
    fill: "#004FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71338 14.9341L4.14643 15.3147L2.91078 17.5967",
    stroke: "#004FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1343 9.72998L21.7012 9.34933L22.9369 7.06737",
    stroke: "#004FFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.0186844932905a8ae1b677bfe0eae923.svg";
export { ForwardRef as ReactComponent };